module.exports = __webpack_public_path__ + "media/play_button.480b9633.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/play_button.svg
// module id = ./src/assets/play_button.svg
// module chunks = 0